<template>
  <div>
    <vx-card title>
      <div>
        <form-wizard
          :nextButtonText="$t('next')"
          :backButtonText="$t('back')"
          color="rgba(var(--vs-primary), 1)"
          :title="$t('editProduct')"
          :subtitle="null"
          :finishButtonText="$t('save')"
          @on-complete="formSubmitted"
          :startIndex="0"
        >
          <!-- tab 1 content -->
          <tab-content :title="$t('productInformation')" class="mb-5" :before-change="step1">
            <step-1 :sendData="sendData"></step-1>
          </tab-content>

          <!-- tab 2 content -->
          <tab-content :title="$t('selectCategoryAndFeature')" :before-change="step3">
            <step-2
              :sendData="sendData"
              :categories="categories"
              :properties="properties"
              @step2="step2"
            ></step-2>
          </tab-content>

          <!-- tab 3 content -->
          <tab-content :title="$t('uploadImage')" :before-change="step4">
            <step-3
              :count="count"
              :status="status"
              :photos="photos"
              @clear="clear"
              @removeImage="removeImage"
              @upload="upload"
            ></step-3>
          </tab-content>
          <!-- tab 4 content -->
          <tab-content :title="$t('imagesettings')">
            <div class="container-fluid">
              <div class="row mt-base">
                <div v-if="nows == true" class="col-12">
                  <iframe
                    class="d-flex vh-100"
                    width="100%"
                    id="prodiframe"
                    src="https://panel.360photoboxcloud.com/viewer360/controllerindex.html"
                    frameborder="0"
                    v-on:load="onloaded"
                    scrolling="no"
                  ></iframe>
                </div>
                <div id="settings" style="display:none;">
                  <h4 id="direction">false</h4>
                  <h4 id="interaction">drag</h4>
                  <h4 id="sensitivity">2</h4>
                  <h4 id="inertia">4</h4>
                  <h4 id="inertia_speed">0</h4>
                  <h4 id="autospin">Infinite</h4>
                  <h4 id="autospin_rpm">10</h4>
                  <h4 id="magnification">3</h4>
                  <h4 id="animation_speed">200</h4>
                  <h4 id="fullscreen_style">c</h4>
                  <h4 id="fullscreen_size">9</h4>
                  <h4 id="fullscreen_position">top-right</h4>
                  <h4 id="bg-color"></h4>
                  <h4 id="image_no">1</h4>
                  <h4 id="loading-indicator">true</h4>
                  <h4 id="variant_load_on">start</h4>
                  <h4 id="fullscreen">true</h4>
                  <h4 id="zoom">true</h4>
                  <h4 id="manuel_spin">true</h4>
                  <h4 id="auto_spin_state">true</h4>
                </div>
              </div>
            </div>
          </tab-content>
        </form-wizard>
      </div>
    </vx-card>
  </div>
</template>

<script>
/* eslint-disable */
import http from "../../../http/http-helper";
import notify from "../../../shared/toast";
import iframeLang from "./iframe-lang-helper";
import Step_1 from "./ProductEditComponents/Step1";
import Step_2 from "./ProductEditComponents/Step2";
import Step_3 from "./ProductEditComponents/Step3";

export default {
  components: {
    "step-1": Step_1,
    "step-2": Step_2,
    "step-3": Step_3,
  },
  data() {
    return {
      isVideos: [],
      categories: [],
      properties: [],
      sendData: {
        Name: "",
        ProductCode: "",
        ProductBarcode: "",
        CategoryId: "",
        FrameCount: "",
        Width: "1920",
        Height: "1080",
        ProductProperties: [],
        ProductFiles: [],
        ProductSettings: [],
      },
      photos: [],
      nows: false,
    };
  },
  computed: {
    status: function () {
      if (this.photos.length == 0) return true;
      return false;
    },
    count: function () {
      return this.photos.length;
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.sendData.Name != "" &&
        this.sendData.ProductCode != ""
      );
    },
    inputWidth: {
      get() {
        return this.sendData.Width;
      },
      set(val) {
        this.sendData.Width = val;
      },
    },
    inputHeight: {
      get() {
        return this.sendData.Height;
      },
      set(val) {
        this.sendData.Height = val;
      },
    },
  },
  methods: {
    onloaded() {
      var iframe = document.getElementById("prodiframe");
      var firstiframe = iframe.contentDocument.querySelector("iframe");
      var lastiframe = firstiframe.contentDocument.querySelector("div");
      iframeLang.changeLang(iframe, this);
      if (this.sendData.ProductSettings.length > 0) {
        this.sendData.ProductSettings.forEach((item, index) => {
          if (index == 0)
            lastiframe.setAttribute(
              "data-reverse_spin",
              this.sendData.ProductSettings[0].settingValue
            );
          if (index == 1)
            lastiframe.setAttribute(
              "data-manual_spin_interaction",
              this.sendData.ProductSettings[1].settingValue
            );
          if (index == 2)
            lastiframe.setAttribute(
              "data-manual_spin_sensitivity",
              this.sendData.ProductSettings[2].settingValue
            );
          if (index == 3)
            lastiframe.setAttribute(
              "data-manual_spin_inertia",
              this.sendData.ProductSettings[3].settingValue
            );
          if (index == 5)
            lastiframe.setAttribute(
              "data-auto_spin_count",
              this.sendData.ProductSettings[5].settingValue
            );
          if (index == 6)
            lastiframe.setAttribute(
              "data-auto_spin_speed",
              this.sendData.ProductSettings[6].settingValue
            );
          if (index == 8)
            lastiframe.setAttribute(
              "data-zoom_speed",
              this.sendData.ProductSettings[8].settingValue
            );
          if (index == 9)
            lastiframe.setAttribute(
              "data-fullscreen_icon_variant",
              this.sendData.ProductSettings[9].settingValue
            );
          if (index == 10)
            lastiframe.setAttribute(
              "data-fullscreen_icon_size",
              this.sendData.ProductSettings[10].settingValue
            );
          if (index == 12)
            lastiframe.setAttribute(
              "data-background_color",
              this.sendData.ProductSettings[12].settingValue
            );
          if (index == 16)
            lastiframe.setAttribute(
              "data-fullscreen",
              this.sendData.ProductSettings[16].settingValue
            );
          if (index == 17)
            lastiframe.setAttribute(
              "data-zoom",
              this.sendData.ProductSettings[17].settingValue
            );
          if (index == 18)
            lastiframe.setAttribute(
              "data-manual_spin",
              this.sendData.ProductSettings[18].settingValue
            );
          if (index == 19)
            lastiframe.setAttribute(
              "data-auto_spin",
              this.sendData.ProductSettings[19].settingValue
            );
        });

        lastiframe.setAttribute(
          "data-instruction_language",
          localStorage.getItem("lang").split("-")[0]
        );
      }
      let datas = [this.photos, this.sendData.ProductSettings];
      setTimeout(() => {
        iframe.contentWindow.postMessage(datas, "*");

        this.$vs.loading.close();
      }, 700);
    },
    checknumWidth: function (event) {
      this.sendData.Width = this.sendData.Width.replace(/[^0-9]/g, "");
    },
    checknumHeight: function (event) {
      this.sendData.Height = this.sendData.Height.replace(/[^0-9]/g, "");
    },
    getDetailProduct() {
      http
        .get(`/products/getbyproductid?productId=${this.$route.params.id}`)
        .then((response) => {
          this.sendData.CategoryId = response.categoryId;

          response.productProperties.forEach((element) => {
            this.properties.push({
              id: element.propertyId,
              propertyName: element.propertyName,
              value: element.value,
              status: "old",
            });
          });
          response.productFiles.forEach((element, index) => {
            if (element.isVideo == true) {
              this.isVideos.push(element);
            }
            if (element.isVideo == false) {
              this.photos.push({
                img: "https://api.360photoboxcloud.com/" + element.fileName,
                allFile: "",
                FileId: element.fileId,
                Line: element.line,
                uploaded: "uploaded",
              });
              this.sendData.ProductFiles.push({
                FileId: element.fileId,
                Line: element.line,
                upload: "uploaded",
                img: "https://api.360photoboxcloud.com/" + element.fileName,
              });
            }
          });

          this.sendData.Name = response.name;
          this.sendData.ProductCode = response.productCode;
          this.sendData.Width = response.width;
          this.sendData.Height = response.height;
          this.sendData.FrameCount = response.frameCount;
          this.sendData.ProductBarcode = response.productBarcode;
          this.sendData.ProductSettings = response.productSettings;
          response.productSettings.forEach((element, index) => {
            document.getElementById(element.settingKey).textContent =
              element.settingValue;
          });
        });
    },
    clear() {
      this.$vs.loading();
      this.photos = [];
      document.getElementById("uploader").value = "";
      setTimeout(() => {
        this.$vs.loading.close();
      }, 1000);
    },
    step1() {
      if (
        this.sendData.Name == "" ||
        this.sendData.Name.length < 3 ||
        this.sendData.ProductCode == "" ||
        this.sendData.ProductCode.length < 3 ||
        this.sendData.ProductBarcode == "" ||
        this.sendData.ProductBarcode.length < 3
      ) {
        notify.warning(this.$t("fillBlanks"));
        return false;
      }

      return new Promise((resolve, reject) => {
        let path = "/categories/GetList";
        http
          .get(path)
          .then((response) => {
            this.categories = response;
            return resolve(true);
          })
          .catch((err) => {
            return reject(false);
          });
      });
    },
    step2() {
      this.properties = [];
      if (this.sendData.CategoryId == null)
        return notify.warning(this.$t("selectatleastone"));
      return new Promise((resolve, reject) => {
        let path = "/properties/getlistbycategoryids";
        http
          .post(path, {
            categoryIds: [this.sendData.CategoryId],
          })
          .then((response) => {
            this.properties.forEach((item, index) => {
              if (item.status == "new") {
                this.properties.splice(index, 1);
              }
            });
            this.properties.forEach((el, co) => {
              if (el.status == "old") {
                if (
                  response.filter((item) => {
                    return item.id == el.id;
                  }) == ""
                ) {
                  this.properties.splice(co, 1);
                }
              }
            });
            response.forEach((element, index) => {
              if (
                this.properties.filter((item) => {
                  return item.id == element.id;
                }) == ""
              ) {
                this.properties.push({
                  id: element.id,
                  propertyName: element.propertyName,
                  value: "",
                  status: "new",
                });
              }
            });

            // for (let index = 0; index < 2; index++) {
            this.properties.forEach((item, index) => {
              if (item.status == "new") {
                this.properties.splice(index, 1);
              }
            });
            this.properties.forEach((el, co) => {
              if (el.status == "old") {
                if (
                  response.filter((item) => {
                    return item.id == el.id;
                  }) == ""
                ) {
                  this.properties.splice(co, 1);
                }
              }
            });
            response.forEach((element, index) => {
              if (
                this.properties.filter((item) => {
                  return item.id == element.id;
                }) == ""
              ) {
                this.properties.push({
                  id: element.id,
                  propertyName: element.propertyName,
                  value: "",
                  status: "new",
                });
              }
            });

            return resolve(true);
          })
          .catch((err) => {
            reject(false);
          });
      });
    },
    step3() {
      if (this.sendData.CategoryId == null || this.sendData.CategoryId == "") {
        notify.warning(this.$t("selectatleastone"));
        return false;
      }

      return true;
    },
    removeImage(index, itemId) {
      this.$vs.loading();
      this.photos.splice(index, 1);
      this.sendData.ProductFiles.forEach((item, index) => {
        if (item.id == itemId) this.sendData.ProductFiles.splice(index, 1);
      });
      document.getElementById("uploader").value = "";
      setTimeout(() => {
        this.$vs.loading.close();
      }, 1000);
    },
    upload(event) {
      for (let index = 0; index < event.target.files.length; index++) {
        const filereader = new FileReader();
        filereader.addEventListener("load", () => {
          var image = new Image();
          image.src = filereader.result;
          this.photos.push({
            fileId: "",
            img: filereader.result,
            allFile: event.target.files[index],
            FileId: "",
            Line: "",
            uploaded: "",
          });
        });

        filereader.readAsDataURL(event.target.files[index]);
      }
    },
    async step4() {
      let status = true;

      const values = await Object.values(this.$validator.flags).forEach(
        (element, index) => {
          if (index == 3 && element.valid == false)
            if (this.sendData.Width < 50 || this.sendData.Width == "")
              status = false;
          if (index == 4 && element.valid == false)
            if (this.sendData.Height < 50 || this.sendData.Height == "")
              status = false;
        }
      );
      if (status == false) return;

      if (this.photos.length == 0)
        return notify.warning(this.$t("selectimage"));

      this.$vs.loading({
        text: "Loading 0 %",
      });

      this.sendData.CategoryId = parseInt(this.sendData.CategoryId);
      this.sendData.FrameCount = parseInt(this.sendData.FrameCount);
      this.sendData.Width = parseInt(this.sendData.Width);
      this.sendData.Height = parseInt(this.sendData.Height);

      var load = document.getElementsByClassName("title-loading");

      var all = this;

      for (let index = 0; index < this.photos.length; index++) {
        if (this.photos[index].uploaded != "uploaded") {
          let formData = new FormData();
          formData.set("file", all.photos[index].allFile);
          let request = await all.uploadPhotos(formData, index, load);
        } else {
          all.photos[index].Line = index + 1;

          setTimeout(() => {
            load[0].innerHTML =
              "Loading " +
              Math.ceil(((index + 1) / all.photos.length) * 100) +
              " %";
          }, 200);
          if (index + 1 == all.photos.length) {
            all.uploadedOk();
          }
        }
      }
      return true;
    },
    uploadPhotos(formData, index, load) {
      let path = "/files/Upload";
      http.upload(path, formData).then((response) => {
        this.sendData.ProductFiles.push({
          FileId: parseInt(response.data.id),
          Line: index + 1,
          upload: "uploaded",
          img: "https://api.360photoboxcloud.com/" + response.data.fileName,
        });
        this.photos[index].img =
          "https://api.360photoboxcloud.com/" + response.data.fileName;
        this.photos[index].uploaded = "uploaded";
        this.photos[index].FileId = parseInt(response.data.id);
        this.photos[index].Line = parseInt(index + 1);

        setTimeout(() => {
          load[0].innerHTML =
            "Loading " +
            Math.ceil(((index + 1) / this.photos.length) * 100) +
            " %";
        }, 200);
        if (index + 1 == this.photos.length) {
          this.uploadedOk();
        }
      });
    },
    uploadedOk() {
      for (let i = 0; i < this.photos.length; i += 1) {
        if (typeof this.photos[i] === "object") {
          try {
            this.photos[i] = JSON.parse(JSON.stringify(this.photos[i]));
          } catch (e) {
            console.error(e);
          }
        }
      }
      this.nows = false;
      setTimeout(() => {
        this.nows = true;
      }, 400);
    },
    async formSubmitted() {
      let last = {
        Id: parseInt(this.$route.params.id),
        Name: this.sendData.Name,
        ProductCode: this.sendData.ProductCode,
        ProductBarcode: this.sendData.ProductBarcode,
        CategoryId: parseInt(this.sendData.CategoryId),
        FrameCount: parseInt(this.sendData.FrameCount),
        Width: parseInt(this.sendData.Width),
        Height: parseInt(this.sendData.Height),
        ProductProperties: [],
        ProductFiles: [],
        ProductSettings: [],
      };
      this.properties.forEach((element) => {
        last.ProductProperties.push({
          PropertyId: element.id,
          Value: element.value,
        });
      });
      this.photos.forEach((element, index) => {
        last.ProductFiles.push({
          FileId: parseInt(element.FileId),
          Line: element.Line,
        });
      });
     /* this.isVideos.forEach((item) => {
        last.ProductFiles.push(item);
      });*/
      last.ProductSettings.push(
        {
          SettingKey: "direction",
          SettingValue: document.getElementById("direction").textContent,
        },
        {
          SettingKey: "interaction",
          SettingValue: document.getElementById("interaction").textContent,
        },
        {
          SettingKey: "sensitivity",
          SettingValue: document.getElementById("sensitivity").textContent,
        },
        {
          SettingKey: "inertia",
          SettingValue: document.getElementById("inertia").textContent,
        },
        {
          SettingKey: "inertia_speed",
          SettingValue: document.getElementById("inertia_speed").textContent,
        },
        {
          SettingKey: "autospin",
          SettingValue:
            document.getElementById("autospin").textContent == "Infinite"
              ? "1000000"
              : document.getElementById("autospin").textContent,
        },
        {
          SettingKey: "autospin_rpm",
          SettingValue: document.getElementById("autospin_rpm").textContent,
        },
        {
          SettingKey: "magnification",
          SettingValue: document.getElementById("magnification").textContent,
        },
        {
          SettingKey: "animation_speed",
          SettingValue: document.getElementById("animation_speed").textContent,
        },
        {
          SettingKey: "fullscreen_style",
          SettingValue: document.getElementById("fullscreen_style").textContent,
        },
        {
          SettingKey: "fullscreen_size",
          SettingValue: document.getElementById("fullscreen_size").textContent,
        },
        {
          SettingKey: "fullscreen_position",
          SettingValue: document.getElementById("fullscreen_position")
            .textContent,
        },
        {
          SettingKey: "bg-color",
          SettingValue:
            document.getElementById("bg-color").textContent == ""
              ? "transparent"
              : document.getElementById("bg-color").textContent,
        },
        {
          SettingKey: "image_no",
          SettingValue: document.getElementById("image_no").textContent,
        },
        {
          SettingKey: "loading-indicator",
          SettingValue: document.getElementById("loading-indicator")
            .textContent,
        },
        {
          SettingKey: "variant_load_on",
          SettingValue: document.getElementById("variant_load_on").textContent,
        },
        {
          SettingKey: "fullscreen",
          SettingValue: document.getElementById("fullscreen").textContent,
        },
        {
          SettingKey: "zoom",
          SettingValue: document.getElementById("zoom").textContent,
        },
        {
          SettingKey: "manuel_spin",
          SettingValue: document.getElementById("manuel_spin").textContent,
        },
        {
          SettingKey: "auto_spin_state",
          SettingValue: document.getElementById("auto_spin_state").textContent,
        }
      );
      let path = "/products/update";
      http.post(path, last).then((response) => {
        notify.success(this.$t("saved"), response.message);
        this.$vs.loading.close();
        this.$router.push("/products/detail/" + this.$route.params.id);
      });
    },
  },
  created() {
    this.getDetailProduct();
  },
};
</script>

<style scoped>
.width {
  width: 250px !important;
}
.width-1 {
  width: 350px !important;
}
.height {
  height: 100px !important;
}
.alt {
  margin-bottom: 30px;
}
.orta-1 {
  display: flex;
  justify-content: center;
}
.orta {
  display: grid;
  justify-content: center;
}

.centerr-2 {
  display: flex;
  justify-content: center;
  height: 40px !important;
  margin-top: 30px;
  width: 50px;
}
.color {
  color: red;
}
.list-item {
  transition: all 1s;
}

input[type="file"] {
  cursor: pointer !important;
  font: 300 14px sans-serif;
  color: #9e9e9e;
}
input[type="file"]::-webkit-file-upload-button {
  font: 300 14px sans-serif;
  background: #7367f0;
  border: 0;
  padding: 12px 25px;
  cursor: pointer;
  color: #fff;
  text-transform: uppercase;
  border-radius: 30px;
}

input[type="file"]::-ms-browse {
  font: 300 14px "Roboto", sans-serif;
  background: #7367f0;
  border: 0;
  padding: 12px 25px;
  cursor: pointer;
  color: #fff;
  text-transform: uppercase;
}
.photo360 {
  margin-top: 100px;
  margin-left: 130px;
}
.cards {
  width: 400px;
  height: 190px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.cards-1 {
  width: 450px;
  height: 120px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.cards {
  width: 400px;
  height: auto;
  padding-top: 10px;
}
.orta-1 {
  display: grid;
  justify-content: center;
}
.colors {
  background-color: rgb(211, 211, 211);
}
.ortalama {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.ortalama-1 {
  display: grid;
  justify-content: center;
  align-items: center;
}
</style>
